import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { Grade } from "../../../../api/types";
import { SentimentBlank } from "../../assets/icon/SentimentBlank";
import { SentimentNeutral } from "../../assets/icon/SentimentNeutral";
import { SentimentPartiallySatisfied } from "../../assets/icon/SentimentPartiallySatisfied";
import { SentimentSatisfied } from "../../assets/icon/SentimentSatisfied";
import { SentimentVerySatisfied } from "../../assets/icon/SentimentVerySatisfied";

const styles = StyleSheet.create({
	tableContainer: {
		flexDirection: "column",
	},
	imageHeader: {
		width: 60,
	},
	content: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontSize: 13,
		marginLeft: 20,
		width: 600,
		textAlign: "justify",
	},
});

interface AggregatedRowProps {
	gradeList: Grade[];
}
export const AggregatedTable: React.FC<AggregatedRowProps> = ({
	gradeList,
}) => {
	const aggMap: Map<JSX.Element, string> = new Map();
	const sentimentBlank = React.cloneElement(<SentimentBlank />, { key: "1" });
	const sentimentNeutral = React.cloneElement(<SentimentNeutral />, {
		key: "2",
	});
	const sentimentPartiallySatisfied = React.cloneElement(
		<SentimentPartiallySatisfied />,
		{ key: "3" },
	);
	const sentimentSatisfied = React.cloneElement(<SentimentSatisfied />, {
		key: "4",
	});
	const sentimentVerySatisfied = React.cloneElement(
		<SentimentVerySatisfied />,
		{ key: "5" },
	);

	aggMap.set(sentimentBlank, "");
	aggMap.set(sentimentNeutral, "");
	aggMap.set(sentimentPartiallySatisfied, "");
	aggMap.set(sentimentSatisfied, "");
	aggMap.set(sentimentVerySatisfied, "");

	if (gradeList) {
		gradeList.forEach((grade) => {
			let sentiment: JSX.Element;
			switch (grade.grade) {
				case "1":
					sentiment = sentimentBlank;
					break;
				case "2":
					sentiment = sentimentNeutral;
					break;
				case "3":
					sentiment = sentimentPartiallySatisfied;
					break;
				case "4":
					sentiment = sentimentSatisfied;
					break;
				case "5":
					sentiment = sentimentVerySatisfied;
					break;
				default:
					sentiment = sentimentVerySatisfied;
			}
			let aggregatedEntries: string = aggMap.get(sentiment) as string;
			aggregatedEntries =
				aggregatedEntries === ""
					? grade.name
					: aggregatedEntries + "; " + grade.name;
			aggMap.set(sentiment, aggregatedEntries);
		});
	}

	return (
		<View style={styles.tableContainer}>
			{[...aggMap.keys()].map((sentiment, i) => (
				<View
					key={i}
					style={{
						borderWidth: 1,
						borderTopWidth: i === 0 ? 1 : 0,
						flexDirection: "row",
					}}
				>
					<View style={styles.imageHeader}>{sentiment}</View>
					<Text style={styles.content}>{aggMap.get(sentiment)}</Text>
				</View>
			))}
		</View>
	);
};
